import {
  calculatePriceCeramic,
  calculatePriceWood,
  getShapePrice,
  calculateEdgePrice,
} from "./calculatePrice";

export class BoardManager {
  constructor(
    activeProduct,
    setActiveProduct,
    basePrice,
    setPrice,
    setState,
    state,
    resetLegs
  ) {
    this.activeProduct = activeProduct;
    this.setActiveProduct = setActiveProduct;
    this.basePrice = basePrice;
    this.setPrice = setPrice;
    this.setState = setState;
    this.state = state;
    this.resetLegs = resetLegs;
  }

  resetDownstream(step) {
    const newState = {
      completedMaterials: false,
      completedParametters: false,
    };

    if (step === "material") {
      newState.activeItem = null;
      newState.finisher = null;
      newState.type = null;
      newState.noColors = null;
      newState.weight = null;
      newState.shape = null;
      newState.edge_shape = null;
      newState.cesljano = null;
      newState.isIncreased = false;
      newState.isIncreasedShape = false;
      this.setPrice(0);
    }

    if (step === "finisher") {
      newState.noColors = null;
      newState.type = null;
      newState.color = null;
      newState.weight = null;
      newState.shape = null;
      newState.edge_shape = null;
      newState.cesljano = null;
      newState.isIncreased = false;
      newState.isIncreasedShape = false;
    }

    if (step === "type" || step === "noColors" || step === "color") {
      newState.weight = null;
      newState.shape = null;
      newState.edge_shape = null;
      newState.cesljano = null;
      newState.isIncreased = false;
      newState.isIncreasedShape = false;
    }

    if (step === "weight") {
      newState.completedMaterials = true;
      newState.shape = null;
      newState.edge_shape = null;
      newState.cesljano = null;
      newState.isIncreased = false;
      newState.isIncreasedShape = false;
    }

    if (step === "shape") {
      newState.completedMaterials = true;
      newState.edge_shape = null;
      newState.cesljano = null;
    }

    if (step === "edge_shape") {
      newState.completedMaterials = true;

      newState.cesljano = null;
    }
    Object.assign(newState, this.resetLegs);
    this.setState((prev) => ({ ...prev, ...newState }));
  }

  selectMaterial(item) {
    this.resetDownstream("material");

    this.setState((prev) => ({
      ...prev,
      activeItem: item,
    }));
    this.setActiveProduct((prev) => ({
      ...prev,
      board: { Materijal: item.name },
      legs: {},
    }));

    if (item.name === "Keramika") {
      this.setPrice(calculatePriceCeramic(this.basePrice, this.activeProduct));
    } else {
      this.setPrice(0);
    }
  }

  selectFinisher(finisher) {
    this.resetDownstream("finisher");
    this.setState((prev) => ({ ...prev, finisher }));
    this.setActiveProduct((prev) => ({
      ...prev,
      board: { Materijal: prev.board.Materijal, "Vrsta drveta": finisher.name },
      legs: {},
    }));
  }

  selectType(type) {
    this.resetDownstream("type");
    this.setState((prev) => ({ ...prev, type }));
    this.setActiveProduct((prev) => ({
      ...prev,
      board: {
        Materijal: prev.board.Materijal,
        "Vrsta drveta": prev.board["Vrsta drveta"],
        Boja: type.name,
      },
      legs: {},
    }));
  }

  selectNoColors(type) {
    this.resetDownstream("noColors");
    this.setState((prev) => ({ ...prev, noColors: type.name }));
    this.setActiveProduct((prev) => ({
      ...prev,
      board: {
        Materijal: prev.board.Materijal,
        "Vrsta drveta": prev.board["Vrsta drveta"],
        Boja: type.name,
      },
      legs: {},
    }));
  }

  selectColor(color) {
    this.resetDownstream("color");
    const key = this.state.activeItem?.has_finisher ? "Boja" : "Model";
    this.setState((prev) => ({ ...prev, color: color.name }));

    this.setActiveProduct((prev) => ({
      ...prev,
      board: {
        Materijal: prev.board.Materijal,
        "Vrsta drveta": prev.board["Vrsta drveta"],
        [key]: color.name,
      },
      legs: {},
    }));

    if (
      this.activeProduct.board?.Materijal === "Keramika" &&
      !this.state.activeItem?.has_finisher
    ) {
      this.setPrice(calculatePriceCeramic(this.basePrice, this.activeProduct));
    }
  }

  selectWeight(weight) {
    this.resetDownstream("weight");
    this.setState((prev) => ({ ...prev, weight }));
    this.setActiveProduct((prev) => ({
      ...prev,
      board: {
        Materijal: prev.board.Materijal,
        "Vrsta drveta": prev.board["Vrsta drveta"],
        Boja: prev.board.Boja,
        Debljina: weight.name,
      },
      legs: {},
    }));
    let price = calculatePriceWood(this.activeProduct, weight, this.basePrice);
    if (this.state.shape && this.activeProduct.board.Materijal === "Drvo") {
      price += getShapePrice(this.activeProduct, this.basePrice);
    }
    this.setPrice(price);
  }

  selectShape(shape) {
    this.resetDownstream("shape");
    this.setState((prev) => ({ ...prev, shape }));

    this.setActiveProduct((prev) => ({
      ...prev,
      board: {
        Materijal: prev.board.Materijal,
        "Vrsta drveta": prev.board["Vrsta drveta"],
        Boja: prev.board.Boja,
        Model: prev.board.Model,
        Debljina: prev.board.Debljina,
        Oblik: shape.name,
      },
      legs: {},
    }));

    if (this.activeProduct.board.Materijal === "Drvo") {
      const shapePrice = getShapePrice(this.activeProduct, this.basePrice);
      if (shape.increase_price && !this.state.isIncreasedShape) {
        this.setPrice((prev) => prev + shapePrice);
        this.setState((prev) => ({ ...prev, isIncreasedShape: true }));
      } else if (!shape.increase_price && this.state.isIncreasedShape) {
        this.setPrice((prev) => prev - shapePrice);
        this.setState((prev) => ({ ...prev, isIncreasedShape: false }));
      }
    }
  }

  selectEdgeShape(edge) {
    this.resetDownstream("edge_shape");
    this.setState((prev) => ({ ...prev, edge_shape: edge }));

    this.setActiveProduct((prev) => ({
      ...prev,
      board: {
        Materijal: prev.board.Materijal,
        "Vrsta drveta": prev.board["Vrsta drveta"],
        Boja: prev.board.Boja,
        Model: prev.board.Model,
        Debljina: prev.board.Debljina,
        Oblik: prev.board.Oblik,
        "Oblik ivice": edge.name,
      },
      legs: {},
    }));

    const edgePrice = calculateEdgePrice(this.activeProduct, this.basePrice);
    if (edge.increase_price && !this.state.isIncreased) {
      this.setPrice((prev) => prev + edgePrice);
      this.setState((prev) => ({ ...prev, isIncreased: true }));
    } else if (!edge.increase_price && this.state.isIncreased) {
      this.setPrice((prev) => prev - edgePrice);
      this.setState((prev) => ({ ...prev, isIncreased: false }));
    }
  }

  selectCesljano(color) {
    this.setState((prev) => ({ ...prev, cesljano: color }));
    this.setActiveProduct((prev) => ({
      ...prev,
      board: { ...prev.board, "Češljano drvo": color.name },
      legs: {},
    }));
  }
}
